var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallWashmenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7295_17994)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.5 38C28.7173 38 37 29.4934 37 19C37 8.50659 28.7173 0 18.5 0C8.28273 0 0 8.50659 0 19C0 29.4934 8.28273 38 18.5 38Z",
    fill: "#00A368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9727 21.4644C23.4361 21.0626 24.1385 21.111 24.5434 21.571L26.4946 23.7885C26.8995 24.2485 26.8508 24.9457 26.3873 25.3475L25.0361 26.5192C24.3044 27.076 23.6458 26.9986 23.6361 26.9937C23.358 26.9405 22.8019 27.0421 22.3922 26.9163C20.8019 26.4176 18.5189 25.4105 15.914 22.4522C13.3091 19.4987 12.4603 16.9422 12.0506 15.175C11.9286 14.623 12.0701 13.9888 12.0359 13.6498C12.0359 13.6402 12.0115 12.9914 12.5774 12.5023C12.6213 12.4685 12.6506 12.4346 12.675 12.4055L13.6116 11.5776L14.0018 11.2725C14.4652 10.8707 15.1677 10.9191 15.5726 11.3791L17.5238 13.5966C17.9287 14.0565 17.8799 14.7538 17.4165 15.1556L15.7335 16.6178C16.3774 17.8864 17.075 19.0581 18.2702 20.4186C19.3141 21.6049 20.1921 22.3117 21.1921 23.0186L22.9727 21.4644Z",
    fill: "#00A368"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7295_17994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallWashmenIcon);
export default __webpack_public_path__ + "static/media/call-washmen-icon.5e98ca403a4f15f860cbdede2a9b28e1.svg";
export { ForwardRef as ReactComponent };